var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#FEFEFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#64696C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10C7.44772 10 7 10.4477 7 11V20C7 20.5523 7.44772 21 8 21H22C22.5523 21 23 20.5523 23 20V11C23 10.4477 22.5523 10 22 10H8ZM21.8241 11L8.17591 11L8.31311 11.1102L13.9236 15.6166L13.9236 15.6167C14.2348 15.8667 14.6133 16 15 16C15.3867 16 15.7652 15.8667 16.0764 15.6167L16.0764 15.6166L21.6869 11.1102L21.8241 11ZM8 12.1413V20H22V12.1413L16.7027 16.3963L16.7026 16.3963C16.2171 16.7863 15.6185 17 15 17C14.3814 17 13.7829 16.7863 13.2973 16.3963L8 12.1413Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.a173b7914c17ffc6db281f3529312c0a.svg";
export { ForwardRef as ReactComponent };